'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n'], ['\n  display: flex;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: none;\n'], ['\n  display: none;\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  cursor: pointer;\n  margin: 0px auto;\n\n  ', '\n'], ['\n  cursor: pointer;\n  margin: 0px auto;\n\n  ', '\n']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n    opacity: 0.3;\n  '], ['\n    opacity: 0.3;\n  ']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  max-width: 100%;\n'], ['\n  max-width: 100%;\n']); /* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/forbid-prop-types */
// eslint-disable-line

var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _v = require('uuid/v4');
var _v2 = _interopRequireDefault(_v);
var _a_checkbox_on = require('../../../assets/icons/a_checkbox_on');
var _a_checkbox_on2 = _interopRequireDefault(_a_checkbox_on);
var _a_checkbox_off = require('../../../assets/icons/a_checkbox_off');
var _a_checkbox_off2 = _interopRequireDefault(_a_checkbox_off);
var _Icon = require('../Icon');
var _Icon2 = _interopRequireDefault(_Icon);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject);
var InputHidden = _styledComponents2.default.input(_templateObject2);
var Label = _styledComponents2.default.label(_templateObject3, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject4);
});
var IconStyled = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5);
var Checkbox = function Checkbox(_ref) {
  var disabled = _ref.disabled,
    checked = _ref.checked,
    onChange = _ref.onChange,
    value = _ref.value,
    inputProps = _ref.inputProps,
    iconProps = _ref.iconProps;
  var elementId = (0, _v2.default)();
  var color = checked ? '#6e0ad6' : '#999999';
  return _react2.default.createElement(Content, null, _react2.default.createElement(InputHidden, (0, _extends3.default)({
    id: elementId,
    onChange: onChange,
    disabled: disabled,
    checked: checked,
    type: 'checkbox'
  }, inputProps, {
    value: value
  })), _react2.default.createElement(Label, {
    disabled: disabled,
    htmlFor: elementId
  }, _react2.default.createElement(IconStyled, (0, _extends3.default)({
    color: color,
    svgPath: checked ? _a_checkbox_on2.default : _a_checkbox_off2.default
  }, iconProps))));
};
Checkbox.propTypes = {
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string.isRequired,
  inputProps: _propTypes2.default.object,
  iconProps: _propTypes2.default.object
};
Checkbox.defaultProps = {
  disabled: false,
  onChange: function onChange() {},
  inputProps: {},
  iconProps: {}
};
exports.default = Checkbox;